var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#EE7A5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.154 23.4528C35.154 17.5525 30.6816 13.446 24.2523 13.446C17.5904 13.446 13.0245 18.0556 13.0245 24.7852C13.0245 31.7315 17.4691 36.1363 24.483 36.1363C26.1972 36.1363 27.8418 35.8917 29.0648 35.4701V33.7559C28.2097 34.1516 26.3722 34.4082 24.5108 34.4082C18.6921 34.4082 14.9395 30.6695 14.9395 24.8667C14.9395 19.211 18.7597 15.1602 24.0753 15.1602C29.5142 15.1602 33.239 18.517 33.239 23.4249C33.239 26.7698 32.1373 28.9315 30.4231 28.9315C29.4446 28.9315 28.8878 28.3747 28.8878 27.4201V19.4437H26.8356V21.1022H26.6168C26.0878 19.919 24.8648 19.1852 23.435 19.1852C20.6509 19.1852 18.706 21.496 18.706 24.7991C18.706 28.2534 20.6091 30.5781 23.437 30.5781C25.0279 30.5781 26.2509 29.8025 26.8356 28.4164H27.0543C27.2154 29.7488 28.4523 30.6994 30.0432 30.6994C33.1694 30.6994 35.154 27.8855 35.154 23.4548V23.4528ZM20.8816 24.8528C20.8816 22.4724 21.9554 21.0605 23.777 21.0605C25.6265 21.0605 26.8077 22.5281 26.8077 24.8528C26.8077 27.1775 25.6125 28.659 23.7492 28.659C21.9694 28.659 20.8816 27.2173 20.8816 24.8528Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/@.9b5427934aec0218244cf45a1b6d1763.svg";
export { ForwardRef as ReactComponent };